/**
 * Banner "Showing parts for: <marca> <modelo> <ano>".
 *
 * A seleção vem da query string quando o cliente acabou de escolher a moto, e
 * do localStorage nas navegações seguintes (filtro, ordenação, paginação), que
 * reescrevem a URL e descartariam os parâmetros.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hauer:selected-bike';

  function fromQuery() {
    var q = new URLSearchParams(window.location.search);
    var brand = q.get('sbb_brand');
    var model = q.get('sbb_model');
    if (!brand && !model) return null;
    return {
      brand: brand || '',
      model: model || '',
      year: q.get('sbb_year') || '',
      path: window.location.pathname
    };
  }

  /**
   * O banner só vale para a coleção que o cliente escolheu.
   *
   * Sem essa checagem, a moto guardada apareceria em qualquer coleção: quem
   * selecionasse uma BMW S 1000 RR e depois abrisse "Frame Sliders" leria
   * "Showing parts for: BMW S 1000 RR" sobre uma lista com peças de todas as
   * marcas. O banner existe para garantir compatibilidade — afirmar isso na
   * página errada é pior do que não ter banner nenhum.
   */
  function matchesCurrentPage(bike) {
    var path = bike.path;

    // Entradas gravadas antes deste campo existir guardavam pathname + query.
    if (!path && bike.url) path = bike.url.split('?')[0];
    if (!path) return false;

    return path === window.location.pathname;
  }

  function fromStorage() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || (!data.brand && !data.model)) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function save(bike) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(bike));
    } catch (e) {
      /* modo privado / cookies bloqueados — o banner ainda funciona nesta página */
    }
  }

  function clear() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* nada a fazer */
    }
  }

  function label(bike) {
    return [bike.brand, bike.model, bike.year]
      .filter(function (part) {
        return part && part.length;
      })
      .join(' ');
  }

  function render(root) {
    var bike = fromQuery();

    if (bike) {
      // Só persiste o que veio da URL; assim a moto acompanha o cliente
      // enquanto ele filtra e pagina dentro da coleção.
      save(bike);
    } else {
      bike = fromStorage();
      // A seleção continua guardada — o cliente pode voltar para a coleção
      // dele e o banner reaparece. Aqui ela apenas não é exibida.
      if (bike && !matchesCurrentPage(bike)) bike = null;
    }

    var text = bike ? label(bike) : '';
    if (!text) {
      root.hidden = true;
      return;
    }

    var target = root.querySelector('[data-bike-banner-bike]');
    if (target) target.textContent = text;
    root.hidden = false;
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bike-banner]');

    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        render(root);

        var change = root.querySelector('[data-bike-banner-change]');
        if (change && !change.dataset.bound) {
          change.dataset.bound = '1';
          change.addEventListener('click', function () {
            clear();
          });
        }
      })(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // O tema troca a grade de produtos por AJAX ao filtrar/paginar; se a section
  // for reinjetada, o banner precisa ser reavaliado.
  document.addEventListener('shopify:section:load', boot);
})();
